/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Copy = props => (
  <svg
    viewBox="0 0 118.12 144"
    width="1em"
    height="1em"
    {...props}
    cursor="pointer"
  >
    <title>{props.title || 'Kopier'}</title>
    <g data-name="Layer 2">
      <path
        d="M35.16 63.7H100v7.2H35.16zm0-23.31h36v7.2h-36zm0 46.6H100v7.21H35.16zm0 23.31H100v7.2H35.16zM88.94 16H17v128h101.12V43.8zm2.3 12.8l13.44 12.8H91.24zM24.68 136.32V23.68h58.88v25.6h26.88v87zM7.68 7.68h85.76v5.38l7.68 7.35V0H0v128h10.89v-7.68H7.68z"
        data-name="Layer 1"
      />
    </g>
  </svg>
);

export default extendIcon(Copy);
